import {Injectable, Inject} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { MyCookieService } from './my-cookie.service';
declare var ga: Function;

@Injectable()
export class GoogleAnalyticsService {

  constructor(public router: Router, @Inject(MyCookieService) private cookieService: MyCookieService) 
  {
    if(cookieService.google) {
      this.router.events.subscribe(event => {
        try {
          if (typeof ga === 'function') {
            if (event instanceof NavigationEnd) {
              ga('set', 'page', event.urlAfterRedirects);
              ga('send', 'pageview');
            }
          }
        } catch (e) {
          console.log(e);
        }
      });
    }
  }

  /**
   * Emit google analytics event
   * Fire event example:
   * this.emitEvent("testCategory", "testAction", "testLabel", 10);
   * @param {string} eventCategory
   * @param {string} eventAction
   * @param {string} eventLabel
   * @param {number} eventValue
   
  public emitEvent(eventCategory: string,
   eventAction: string,
   eventLabel: string = null,
   eventValue: number = null) {
    if (typeof ga === 'function') {
      ga('send', 'event', {
        eventCategory: eventCategory,
        eventLabel: eventLabel,
        eventAction: eventAction,
        eventValue: eventValue
      });
    }
  }
  */

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/google-analytics.service.ts